export const container = ({ isMoving, isActive, transitionDuration, isLast }) => ({
    position: 'relative',
    zIndex: 2,
    marginTop: '3.4375rem',

    display: 'flex',
    flexDirection: isLast ? 'column-reverse' : 'column',

    willChange: 'transform, opacity',
    transform: isMoving || !isActive ? 'translateX(-20px)' : 'translateX(0px)',
    opacity: isMoving || !isActive ? '0' : '1',
    transition: `cubic-bezier(0.4, 0.0, 0.2, 1) transform ${transitionDuration}s, cubic-bezier(0.4, 0.0, 0.2, 1) opacity ${transitionDuration}s`,

    tabletLarge: {
        position: 'absolute',
        marginTop: '5rem',
        marginBottom: '13.5625rem',
    },
});

export const link = ({ theme: { colors } }) => ({
    color: colors.blue,
    textDecoration: 'none',
    willChange: 'filter',
});

export const tagsContainer = () => ({
    marginBottom: '1.1875rem',
});

export const tagContainer = ({ theme: { colors } }) => ({
    background: colors.cyan,
    color: colors.black,
});

export const extendTitle = {
    title: ({ hasLink, theme: { colors } }) => ({
        color: hasLink ? colors.blue : colors.black,
        marginBottom: 0,
        marginTop: 0,
        boxShadow: hasLink && `inset 0 -0.1875rem ${colors.blue}`,
        display: 'inline',
        cursor: 'pointer',
        transition: `cubic-bezier(0.4, 0.0, 0.2, 1) color 0.3s`,
        willChange: 'color',
        lineHeight: 1.4,

        ':hover': {
            color: hasLink ? colors.fuchsia : colors.black,
        },
    }),
};

const subtitleBase = {
    fontSize: '1.375rem',
    fontWeight: '500',
    marginTop: '0',
    marginBottom: '1rem',

    maxWidth: '16.9375rem',

    tablet: {
        fontSize: '1.375rem',
        fontWeight: '500',
        maxWidth: 'unset',
    },
};

export const extendSubtitle = {
    title: () => ({
        ...subtitleBase,
    }),
};

export const extendSubtitleB = {
    title: () => ({
        ...subtitleBase,
        marginTop: '1.5rem',
    }),
};

export const buttonsContainer = {
    display: 'flex',
    marginTop: '1rem',
    justifyContent: 'space-between',
    width: 'calc(100% - 2rem)',
};

export const logo = ({ logo }) => ({
    width: '2.75rem',
    height: '6.25rem',
    marginTop: '14rem',
    position: 'absolute',

    backgroundImage: logo ? `url(${logo.desktop})` : undefined,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',

    tablet: {
        position: 'relative',

        marginTop: '1rem',

        width: '6.25rem',
        height: '2.75rem',

        backgroundImage: logo ? `url(${logo.mobile})` : undefined,
    },

    '@media(min-width: 1400px)': {
        width: '2.75rem',
        height: '6.25rem',
        marginTop: '3rem',

        backgroundImage: logo ? `url(${logo.desktop})` : undefined,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
    },
});
